import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

const actions = {
    async fetchData({ rootState }, query) {
        const token = rootState.authToken;

        const { data } = await axios.get(
            addAuthKey(`${api_url}?r=api/reports/couriers/index&${query}`, token)
        );

        return data;
    },
};

export default {
    namespaced: true,
    actions,
};
